export const CREATE_NEW_MERCHANT = {
	value: 'Create_New_Merchant',
	label: 'Create New Merchant'
};
